import { UNAUTHORIZED_CONNECT_TOOLTIP } from '../../constants';
import WithPermissions from './WithPermissions';

const WithConnectOrgPermission = (props: any) => (
  <WithPermissions
    accessValidation={{ type: 'query', queries: [{ permission: 'create:orgs:crm' }] }}
    disabledTooltip={UNAUTHORIZED_CONNECT_TOOLTIP}
    {...props}
  />
);

export default WithConnectOrgPermission;
